import React from 'react';
import { useParams } from 'react-router-dom';
import RequestList from './RequestList';

/**
 * Full-page request view — same UI and action buttons as the request details modal on the list page.
 */
const RequestView: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const requestId = id ? Number(id) : undefined;

  if (!requestId || Number.isNaN(requestId)) {
    return null;
  }

  return <RequestList standaloneRequestId={requestId} />;
};

export default RequestView;
